module.exports = __webpack_public_path__ + "img/1600_QuizFail.ce0a701b.png";